import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import IpoOrderInfo from "./IpoOrderInfo";
import { makeGETRequest } from "../../../Api/api";
import { IPOOrderHistoryResponse } from "./helpers";
import toastr from "toastr";

const IPOOrders = (props: any) => {
  const { currentUser } = props;
  const [ipoOrders, setIPOOrders] = useState<IPOOrderHistoryResponse[]>([]);
  const [isLoadingIPOOrders, setIsLoadingIPOOrders] = useState(false);

  useEffect(() => {
    let mounted = true;
    const fetchIPOOrders = async () => {
      setIsLoadingIPOOrders(true);
      try {
        const response = await makeGETRequest(
          `/ipo/order/history/${currentUser.uuid}/`
        );

        if (mounted && response.status === 200) {
          setIPOOrders(response.data);
        }
      } catch (error) {
        if (mounted) {
          toastr.error("Failed to fetch bond orders");
        }
      } finally {
        if (mounted) {
          setIsLoadingIPOOrders(false);
        }
      }
    };
    if (currentUser?.uuid) {
      fetchIPOOrders();
    }
    return () => {
      mounted = false;
    };
  }, [currentUser?.uuid]);

  const [collapseIndex, setCollapseIndex] = useState(-1);

  return (
    <Box
      sx={{
        pb: 2,
      }}
    >
      {isLoadingIPOOrders ? (
        <CircularProgress color="error" />
      ) : ipoOrders ? (
        ipoOrders
          ?.sort((a, b) => {
            const dateA = new Date(a.insertedAt);
            const dateB = new Date(b.insertedAt);
            return dateB.getTime() - dateA.getTime();
          })
          ?.map((item, index) => (
            <IpoOrderInfo
              key={index}
              index={index}
              collapseIndex={collapseIndex}
              item={item}
              setCollapseIndex={setCollapseIndex}
            />
          ))
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            my: 2,
          }}
        >
          <Typography
            sx={{
              p: 2,
              bgcolor: "#0000001A",
              borderRadius: "12px",
              color: "#9397A4",
            }}
          >
            Error Fetching Bond Orders
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default IPOOrders;
